import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import SaveIcon from '@material-ui/icons/SaveOutlined';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import { TooltipWrapper } from '../../Core/Components/TooltipWrapper/TooltipWrapper';
import { FileItem } from './FileItem';
import addReasourcePng from './assets/add-book-gray.png';
import styles from './FileListItem.scss';

export const FileListItem = ({
  resourceId,
  resource,
  onEditResource,
  onDeleteResource,
  onToggleResource,
  editResourceId,
  editResourceText,
  setEditResourceText,
  onSaveEditResource,
  onCloseEditResource,
  onDeleteArticle,
  onToggleArticle,
  onEditArticle,
  onArticleDragEnd,
  fileActionMenuId,
  setFileActionMenuId,
  anchorEl,
  setAnchorEl,
  setSelectedVidPrevUrl,
  onAddResourceToCollection,
}) => {
  const sortedArticles = resource.articles
    ? Object.keys(resource.articles).sort(
        (a, b) => resource.articles[a].index - resource.articles[b].index
      )
    : [];

  return (
    <div className={styles.container}>
      <div
        className={styles.list_header}
        style={
          editResourceId === resourceId
            ? { paddingLeft: 20, paddingBottom: 10 }
            : null
        }
      >
        {editResourceId === resourceId ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TextField
              value={editResourceText}
              onChange={e => {
                setEditResourceText(e.target.value);
              }}
              InputProps={{
                classes: {
                  root: styles.root_input,
                  input: styles.text_input,
                },
              }}
            />
            <Button onClick={onSaveEditResource} style={{ minWidth: 30 }}>
              <SaveIcon style={{ fontSize: 16, cursor: 'pointer' }} />
            </Button>
            <Button onClick={onCloseEditResource} style={{ minWidth: 30 }}>
              <CloseIcon
                onClick={onCloseEditResource}
                style={{ fontSize: 16, cursor: 'pointer' }}
              />
            </Button>
          </div>
        ) : (
          <div className={styles.list_title}>{resource.resourceName.en}</div>
        )}
        <IconButton
          color="default"
          onClick={event => {
            event.stopPropagation();
            setFileActionMenuId(resourceId);
            setAnchorEl(event.currentTarget);
          }}
          size="small"
          style={{ padding: 5 }}
          disabled={editResourceId}
        >
          <MoreVertIcon style={{ fontSize: 14 }} />
        </IconButton>
        {resource.isEnabled && sortedArticles.length ? null : (
          <VisibilityOffIcon style={{ fontSize: 16, marginRight: 5 }} />
        )}
        <Popover
          id={resourceId}
          open={fileActionMenuId === resourceId}
          anchorEl={anchorEl}
          onClose={event => {
            event.stopPropagation();
            setFileActionMenuId(null);
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              padding: 5,
              alignItems: 'start',
            }}
          >
            <Button
              onClick={onToggleResource}
              style={
                sortedArticles.length
                  ? { minWidth: 30, fontSize: '1.2rem' }
                  : { display: 'none' }
              }
            >
              {resource.isEnabled && sortedArticles.length ? (
                <VisibilityOffIcon
                  style={{ fontSize: 16, cursor: 'pointer', marginRight: 5 }}
                />
              ) : (
                <VisibilityIcon
                  style={{ fontSize: 16, cursor: 'pointer', marginRight: 5 }}
                />
              )}
              {`${
                resource.isEnabled && sortedArticles.length
                  ? 'Hide collection'
                  : 'Show collection'
              }`}
            </Button>

            <Button
              onClick={onEditResource}
              style={{ minWidth: 30, fontSize: '1.2rem' }}
            >
              <EditIcon
                style={{ fontSize: 16, cursor: 'pointer', marginRight: 5 }}
              />
              Edit collection
            </Button>

            <Button
              onClick={onDeleteResource}
              style={{ minWidth: 30, fontSize: '1.2rem' }}
            >
              <DeleteIcon
                style={{ fontSize: 16, cursor: 'pointer', marginRight: 5 }}
              />
              Delete collection
            </Button>
          </div>
        </Popover>
      </div>
      {sortedArticles.length ? (
        <DragDropContext onDragEnd={onArticleDragEnd}>
          <Droppable droppableId="article_droppable" direction="horizontal">
            {provided => (
              <div className={styles.files_list} ref={provided.innerRef}>
                {sortedArticles.map((articleId, index) => {
                  return (
                    <TooltipWrapper
                      title={
                        sortedArticles.length < 2
                          ? ''
                          : 'Drag to reorder resources'
                      }
                      classes={{
                        tooltip: styles.tooltip,
                      }}
                    >
                      <Draggable
                        key={articleId}
                        draggableId={articleId}
                        index={index}
                        isDragDisabled={sortedArticles.length < 2}
                      >
                        {itemProvided => (
                          <div
                            ref={itemProvided.innerRef}
                            {...itemProvided.draggableProps}
                            {...itemProvided.dragHandleProps}
                          >
                            <FileItem
                              article={resource.articles[articleId]}
                              onEditArticle={() => {
                                onEditArticle(articleId);
                              }}
                              onDeleteArticle={() => {
                                onDeleteArticle(articleId);
                              }}
                              onToggleArticle={() => {
                                onToggleArticle(articleId);
                              }}
                              articleId={articleId}
                              fileActionMenuId={fileActionMenuId}
                              setFileActionMenuId={setFileActionMenuId}
                              anchorEl={anchorEl}
                              setAnchorEl={setAnchorEl}
                              setSelectedVidPrevUrl={setSelectedVidPrevUrl}
                            />
                          </div>
                        )}
                      </Draggable>
                    </TooltipWrapper>
                  );
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      ) : (
        <div
          className={styles.empty_card_container}
          onClick={onAddResourceToCollection}
        >
          <img
            src={addReasourcePng}
            style={{ marginBottom: 10, width: 20, height: 20 }}
          />
          <div>Add new resource</div>
        </div>
      )}
    </div>
  );
};

FileListItem.propTypes = {
  resourceId: PropTypes.string.isRequired,
  resource: PropTypes.object.isRequired,
  onEditResource: PropTypes.func.isRequired,
  onDeleteResource: PropTypes.func.isRequired,
  onToggleResource: PropTypes.func.isRequired,
  editResourceId: PropTypes.string,
  editResourceText: PropTypes.string,
  setEditResourceText: PropTypes.func.isRequired,
  onSaveEditResource: PropTypes.func.isRequired,
  onCloseEditResource: PropTypes.func.isRequired,
  onDeleteArticle: PropTypes.func.isRequired,
  onToggleArticle: PropTypes.func.isRequired,
  onEditArticle: PropTypes.func.isRequired,
  onArticleDragEnd: PropTypes.func.isRequired,
  fileActionMenuId: PropTypes.string,
  setFileActionMenuId: PropTypes.func,
  anchorEl: PropTypes.object,
  setAnchorEl: PropTypes.func,
  setSelectedVidPrevUrl: PropTypes.func,
  onAddResourceToCollection: PropTypes.func,
};
